import React, { type FC, type PropsWithChildren } from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';

export const RowActiveCellWrapper: FC<PropsWithChildren> = ({ children }) => (
	<Box xcss={activeCellWrapperStyles} data-class="RowActiveCellWrapper">
		{children}
	</Box>
);

const activeCellWrapperStyles = xcss({
	cursor: 'pointer',
	opacity: 0,
	':hover': {
		opacity: 1,
	},
	':focus': {
		opacity: 1,
	},
	':focus-within': {
		opacity: 1,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableWithRowsActiveCellBase = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'tr:focus [data-class="RowActiveCellWrapper"], tr:hover [data-class="RowActiveCellWrapper"]': {
		opacity: 1,
	},
	// this is separate from the two above because Edge won't apply the :hover or :focus styles with :focus-within
	//  in the same style statement (because it doesn't support focus-within and so ignores the entire selector)
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'tr:focus-within [data-class="RowActiveCellWrapper"]': {
		opacity: 1,
	},
});
